import axios from '../AxiosInstance';

const baseUrlOp ='/operation'
class BeSbUpdetionService{

    getBOE(consignmentId){
        return axios.get(baseUrlOp+'/getBOE?consignmentId='+consignmentId);
    }
    getJobTrackingDetails(consignmentNumber){
        return axios.get(baseUrlOp+'/getJobTrackingDetails?consignmentNumber='+consignmentNumber);
    }
    getJobEntryAssign(consignmentNumber){
        return axios.get(baseUrlOp+'/getJobEntryAssign?consignmentId='+consignmentNumber); 
    }
    insertBOE(details){
        return axios.post(baseUrlOp+'/insertBOE',details); 
    }
    updateBOE(details){
        return axios.put(baseUrlOp+'/updateBOE',details); 
    }
    deleteBOE(consignmentId,flag){
        return axios.delete(baseUrlOp+'/deleteBOE?consignmentId='+consignmentId+'&flag='+flag); 
    }

}

export default new BeSbUpdetionService();